import { useState } from 'react';
import { PiWarningCircleBold } from 'react-icons/pi';
import { Button } from '../../../../../../../components/button/button';
import { Dropdown } from '../../../../../../../components/dropdown/dropdown';
import { Loader } from '../../../../../../../components/loader/loader';
import { DropZone } from '../../../../../../../features/drop-zone/drop-zone';
import { gridTemplates } from '../../../../../../../helpers/mappers';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../../../hooks/use-modal-params';
import { menuTemplateDownload } from '../../../../../../../store/api/dish-menu-api';
import { useDishMenuStore } from '../../../../../../../store/use-dish-menu-store';
import { getMenuId } from '../../menu-informer-helpers';
import s from './menu-informer-file-upload.module.css';
import { MenuInformerUploadedSaveModal } from './menu-informer-uploaded-save-modal/menu-informer-uploaded-save-modal';

export const MenuInformerFileUpload = () => {
  const { t } = useLang();
  const [file, setFile] = useState<File>();
  const { isLoading, menuUpload, uploadedMenu } = useDishMenuStore();
  const menuId = getMenuId();
  const saveUploadedMenuModal = useModalParams('saveUploadedMenu');

  const handleDrop = async (file: File) => {
    const formData = new FormData();
    formData.append('data', file);
    menuId && formData.append('id', menuId);
    menuUpload(formData).then(() => setFile(file));
  };

  return (
    <div className={s.feature}>
      {isLoading && <Loader />}

      <div className={s.alert}>
        <PiWarningCircleBold size={24} color="#d80027" />
        <p>
          {t(
            'Внимание, загружаемые данные перепишут существующее меню! Все предыдущие данные будут удалены!',
          )}
        </p>
      </div>

      <DropZone
        onDrop={handleDrop}
        acceptedFiles={{ 'text/csv': ['.csv'], 'spreadsheet/xlsx': ['.xlsx'] }}
        helpText={t('Формат: XLSX, CSV')}
      />

      <Button
        variant="primary"
        size="lg"
        disabled={!uploadedMenu}
        data-testid="upload-button"
        onClick={() => {
          saveUploadedMenuModal.handleOpenModal();
        }}
      >
        {t('Загрузить файл') + `${file ? ` ${file.name}` : ''}`}
      </Button>

      <Dropdown
        className={s.dropdown}
        optionsClassName={s.options}
        label={t('Скачать шаблон')}
        options={gridTemplates.map((item) => ({
          key: item,
          label: item,
          onClick: () => menuTemplateDownload(item),
        }))}
      />
      {saveUploadedMenuModal.isOpen && (
        <MenuInformerUploadedSaveModal onClose={saveUploadedMenuModal.handleCloseModal} />
      )}
    </div>
  );
};
